module.exports = __webpack_public_path__ + "static/media/view5.415c5f53.jpg";